import { Warrior as WarriorType } from '~/../api/common.types';
import BattleChronicle from '~/components/war/battle/BattleChronicle';
import { useGameContext } from '~/contextProviders/GameContextProvider';

import WarriorDetails from './WarriorDetails';

export default function Warrior({
  facing,
  warrior,
  active,
  victor,
  attackPreview,
  lifeAndDeathRoundOpponent,
}: {
  facing: string;
  warrior: WarriorType;
  active: boolean;
  victor?: number | undefined;
  attackPreview?: string | undefined;
  lifeAndDeathRoundOpponent?: boolean | undefined;
}) {
  const { tournamentParam } = useGameContext();

  return (
    <div
      className={`warrior warrior--${facing} ${
        victor === warrior.warrior_id && 'warrior--victor'
      }`}
    >
      <div className="warrior__body">
        <WarriorDetails
          facing={facing}
          warrior={warrior}
          active={active}
          victor={victor}
          attackPreview={attackPreview}
          lifeAndDeathRoundOpponent={lifeAndDeathRoundOpponent}
        />
      </div>
      <div className="battle-chronicle">
        <BattleChronicle warrior={warrior} tournamentParam={tournamentParam} />
      </div>
    </div>
  );
}
